import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { DataService }   from '../../shared-service/data.service';
import { BaseService }   from '../../shared-service/base.service';
 


@Injectable()
export class GamificationRuleService {

	constructor(private dataService:DataService, private bs: BaseService) {
		this.bs.log('info',"Loaded GamificationRuleService");
	}

	updateStoreData(key: PropertyKey, data: Object) {
        return this.dataService.setStoreData(key, data);
    }

    getStoreData(key: PropertyKey) {
        return this.dataService.getDataStoreData(key);
    }

	getGamificationRulesFromServer(body: Object, key: PropertyKey) {
		let promise = new Promise((resolve, reject) => {
			let controllerMethod = 'Gamification/GetGamificationRules';
			this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
				this.bs.log('info',"Succes in getting result from " + controllerMethod);
				resolve(data);
			}, (err) => {
				this.bs.log('error',err);
				 this.bs.errorHandler(JSON.parse(err.error).Message);
				reject(err);
			}).catch((exception) => {
				 this.bs.errorHandler(exception);
				reject(exception);
			});
		});
		return promise;
	};
}
